import React from "react";
import { Label } from "semantic-ui-react";
import { Checkbox } from "antd";
import { Row, Col } from "react-bootstrap";
import { Typography } from "antd";

const { Text } = Typography;

// Combined reusable component for heading + variables checkbox grid
export default function SelectVariables({ onChange, value }) {
  return (
    <>
      <Label
        style={{
          backgroundColor: "white",
          color: "#18202F",
          fontSize: "14px",
          padding: "0px",
        }}
      >
        Select Variables for Analysis
      </Label>
      <br />
      <Text code>
        * River Flood Typhoon and Storm Surge are default Variables
      </Text>
      <br />
      <Label
        style={{
          backgroundColor: "white",
          color: "#18202F",
          fontSize: "13px",
          padding: "0px",
        }}
      >
        Acute
      </Label>
      <br />

      <Checkbox.Group onChange={onChange} value={value}>
        <Row>
          <Col>
            <div className="variable_card_area">
              <Checkbox
                className="variable_checkbox"
                type="checkbox"
                id="1"
                value="River Flood"
                defaultChecked
                disabled
              />
              <div className="single_variable_card">
                <div className="variable_card_content">
                  <div className="variable_card_icon">
                    <div className="variable_icon variable_icon1"></div>
                  </div>

                  <div className="variable_card_title">
                    <h3>
                      <i className="fa fa-check" aria-hidden="true"></i>
                      River Flood
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col>
            <div className="variable_card_area">
              <Checkbox
                className="variable_checkbox"
                type="checkbox"
                id="2"
                value="Storm Surge"
                defaultChecked
                disabled
              />
              <div className="single_variable_card">
                <div className="variable_card_content">
                  <div className="variable_card_icon">
                    <div className="variable_icon variable_icon2"></div>
                  </div>

                  <div className="variable_card_title">
                    <h3>
                      <i className="fa fa-check" aria-hidden="true"></i>
                      Storm Surge
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col>
            <div className="variable_card_area">
              <Checkbox
                className="variable_checkbox"
                type="checkbox"
                id="3"
                value="Typhoon"
                defaultChecked
                disabled
              />
              <div className="single_variable_card">
                <div className="variable_card_content">
                  <div className="variable_card_icon">
                    <div className="variable_icon variable_icon3"></div>
                  </div>

                  <div className="variable_card_title">
                    <h3>
                      <i className="fa fa-check" aria-hidden="true"></i>
                      Typhoon
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Checkbox.Group>

      <br />

      <Checkbox.Group onChange={onChange} value={value}>
        <Row>
          <Col>
            <div className="variable_card_area">
              <Checkbox
                className="variable_checkbox"
                type="checkbox"
                id="4"
                value="Wild Fire"
              />
              <div className="single_variable_card">
                <div className="variable_card_content">
                  <div className="variable_card_icon">
                    <div className="variable_icon variable_icon4"></div>
                  </div>

                  <div className="variable_card_title">
                    <h3>
                      <i className="fa fa-check" aria-hidden="true"></i>
                      Wildfire
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col>
            <div className="variable_card_area">
              <Checkbox
                className="variable_checkbox"
                type="checkbox"
                id="1"
                value="Landslide"
              />
              <div className="single_variable_card">
                <div className="variable_card_content">
                  <div className="variable_card_icon">
                    <div className="variable_icon variable_icon5"></div>
                  </div>

                  <div className="variable_card_title">
                    <h3>
                      <i className="fa fa-check" aria-hidden="true"></i>
                      Landslide
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col>
            <div className="variable_card_area">
              <Checkbox
                className="variable_checkbox"
                type="checkbox"
                id="1"
                value="Rainfall Flood"
              />
              <div className="single_variable_card">
                <div className="variable_card_content">
                  <div className="variable_card_icon">
                    <div className="variable_icon variable_icon6"></div>
                  </div>

                  <div className="variable_card_title">
                    <h3>
                      <i className="fa fa-check" aria-hidden="true"></i>
                      Rainfall Flood
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <div className="variable_card_area">
              <Checkbox
                className="variable_checkbox"
                type="checkbox"
                id="8"
                value="Extreme Cold"
              />
              <div className="single_variable_card">
                <div className="variable_card_content">
                  <div className="variable_card_icon">
                    <div className="variable_icon variable_icon8"></div>
                  </div>

                  <div className="variable_card_title">
                    <h3>
                      <i className="fa fa-check" aria-hidden="true"></i>
                      Extreme Cold
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <br />

        <Label
          style={{
            backgroundColor: "white",
            color: "#18202F",
            fontSize: "13px",
            padding: "0px",
          }}
        >
          Chronic
        </Label>
        <br />
        <Row>
          <Col>
            <div className="variable_card_area">
              <Checkbox
                className="variable_checkbox"
                type="checkbox"
                id="7"
                value="Extreme Heat"
              />
              <div className="single_variable_card">
                <div className="variable_card_content">
                  <div className="variable_card_icon">
                    <div className="variable_icon variable_icon7"></div>
                  </div>

                  <div className="variable_card_title">
                    <h3>
                      <i className="fa fa-check" aria-hidden="true"></i>
                      Extreme Heat
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col>
            <div className="variable_card_area">
              <Checkbox
                className="variable_checkbox"
                type="checkbox"
                id="8"
                value="Snow Fall"
              />
              <div className="single_variable_card">
                <div className="variable_card_content">
                  <div className="variable_card_icon">
                    <div className="variable_icon variable_icon8"></div>
                  </div>

                  <div className="variable_card_title">
                    <h3>
                      <i className="fa fa-check" aria-hidden="true"></i>
                      Snowfall
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col>
            <div className="variable_card_area">
              <Checkbox
                className="variable_checkbox"
                type="checkbox"
                id="9"
                value="Sea Level Rise"
              />
              <div className="single_variable_card">
                <div className="variable_card_content">
                  <div className="variable_card_icon">
                    <div className="variable_icon variable_icon9"></div>
                  </div>

                  <div className="variable_card_title">
                    <h3>
                      <i className="fa fa-check" aria-hidden="true"></i>
                      Sea Level Rise
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={4}>
            <div className="variable_card_area">
              <Checkbox
                className="variable_checkbox"
                type="checkbox"
                id="10"
                value="Drought"
              />
              <div className="single_variable_card">
                <div className="variable_card_content">
                  <div className="variable_card_icon">
                    <div className="variable_icon variable_icon10"></div>
                  </div>

                  <div className="variable_card_title">
                    <h3>
                      <i className="fa fa-check" aria-hidden="true"></i>
                      Drought
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Checkbox.Group>

      <br />
    </>
  );
}
